export class DatiPersonaliVO {
  datiComuni: boolean;

  datiParticolari: boolean;

  datiGiudiziari: boolean;

  datiRiservati: Boolean; // solo per fascicolo

  privato: boolean; //livello di consultabilità  (pubblico/privato)

  motivoRestrizioni: string;

  condizioniConsultabilita: string;

  condizioniRiproduzione: string;
}
